/*
 * Shared UI timing constants — one number, one feel, across every screen.
 */

/** Search-box debounce, used by the topic screen (symbol grid), the table
 *  screen's navigator, and the REST op list. 100ms: long enough to coalesce a
 *  fast typist's burst (~80–150ms inter-key), short enough that the query fires
 *  near-instantly after the last keystroke — 200ms read as network lag. All
 *  three search paths are cheap to refire mid-burst (server-side caching /
 *  stream supersede), so erring fast is safe. One shared constant so the three
 *  boxes can never drift apart again. */
export const SEARCH_DEBOUNCE_MS = 100;
